import { startOfDay } from '@e3dc-react/shell/Libs/date'
import { ALL_DAYS, BlockingWeeklySchedule, WeekDays } from 'src/Libs/flow/installation/forms'
import { getTimeFromDate, getTimeRangesOverlap } from 'src/Libs/flow/installation/utils'

export const createDefaultBlockingTime = (): BlockingWeeklySchedule => {
  const now = new Date()
  return {
    fromTime: startOfDay(now),
    toTime: startOfDay(now),
    weekDays: {
      monday: false,
      tuesday: false,
      wednesday: false,
      thursday: false,
      friday: false,
      saturday: false,
      sunday: false,
    },
  }
}

type ScheduleConflict = {
  fromTimeMs: number | null
  toTimeMs: number | null
  hasValidTime: boolean
  weekDays: WeekDays
  conflictingScheduleIndex: number | null
  errorWeekdays: WeekDays
}

/** Given an array of schedules, it returns an array of the weekdays that conflict amongs the schedules. */
export const getScheduleConflicts = (schedules: BlockingWeeklySchedule[]): ScheduleConflict[] => {
  const validatedSchedules = schedules.map(mapValidateScheduleTime)

  for (let index = 0; index < validatedSchedules.length; index++) {
    const schedule = validatedSchedules[index]
    if (!schedule.hasValidTime) continue

    for (let checkIndex = index + 1; checkIndex < validatedSchedules.length; checkIndex++) {
      const checkSchedule = validatedSchedules[checkIndex]
      if (!checkSchedule.hasValidTime) continue
      if (!getTimeRangesOverlap(schedule.fromTimeMs!, schedule.toTimeMs!, checkSchedule.fromTimeMs!, checkSchedule.toTimeMs!)) continue

      markConflictingWeekdays(schedule, checkSchedule, index)
    }
  }

  return validatedSchedules
}

const mapValidateScheduleTime = ({ fromTime, toTime, weekDays }: BlockingWeeklySchedule): ScheduleConflict => {
  const fromTimeMs = getTimeFromDate(fromTime)
  const toTimeMs = getTimeFromDate(toTime)
  const hasValidTime = fromTimeMs !== null && toTimeMs !== null && fromTimeMs < toTimeMs

  return {
    fromTimeMs,
    toTimeMs,
    hasValidTime,
    weekDays,
    conflictingScheduleIndex: null as number | null,
    errorWeekdays: {
      monday: false,
      tuesday: false,
      wednesday: false,
      thursday: false,
      friday: false,
      saturday: false,
      sunday: false,
    },
  }
}

const markConflictingWeekdays = (schedule: ScheduleConflict, checkSchedule: ScheduleConflict, index: number): void => {
  for (const day of ALL_DAYS) {
    if (schedule.weekDays[day] && checkSchedule.weekDays[day]) {
      schedule.errorWeekdays[day] = true
      checkSchedule.errorWeekdays[day] = true
      checkSchedule.conflictingScheduleIndex ??= index
    }
  }
}
